import { MODIFY_ACCESS, NEW_ACCESS, REVOKE_ACCESS } from "@api";

export interface BaseFiltersDropdown {
  environments: string[];
  systemNames: string[];
  statuses: string[];

  systemCategories: string[];
  systemTypes: string[];
  deviceTypes: string[];
  withRFs: string[];
}

export interface Filters {
  environment: string;
  dateType: "EFFECTIVE_DATE" | "DATE_REQUESTED" | "";
  status: string;
  systemName: string;
  dateFrom: Date | null;
  dateTo: Date | null;
  typeOfAction:
    | typeof NEW_ACCESS
    | typeof MODIFY_ACCESS
    | typeof REVOKE_ACCESS
    | "";
  systemCategory?: string;
  systemType?: string;
  deviceType?: string;
  withRF?: string;
  isSendBack?: boolean;
}

export const EFFECTIVE_DATE = "EFFECTIVE_DATE";
export const REQUESTED_DATE = "REQUESTED_DATE";
